export enum PaymentMethod {
  PAYG = "PREPAYMENT",
  PAYM = "DIRECT_DEBIT",
  PAY_NON_DD = "ON_DEMAND",
}
